import React from "react";

// ✅ Custom formatted date-time in 24-hour format
const formatTime = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

function BacteriaLogs({ logs }) {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🦠 Bacteria Logs</h1>
      <div style={styles.logsContainer}>
        {logs.length > 0 ? (
          logs.map((log, index) => (
            <div key={index} style={styles.logCard}>
              <p><strong>📌 Device:</strong> {log.dCore}</p>
              <p><strong>🆔 Test ID:</strong> {log.testId}</p>
              <p style={log.testStatus === "Active" ? styles.passStatus : styles.failStatus}>
                <strong>🔬 Status:</strong> {log.testStatus}
              </p>
              <p><strong>🧪 Message:</strong> {log.eVoiceMessage}</p>
              {log.lowCount !== undefined && (<p><strong>Low Count:</strong> {log.lowCount}</p>)}
              <p><strong>📅 Start Date:</strong> {formatTime(log.timestamp)}</p>
              <p><strong>Progress :</strong> {log.progress}</p>
              <p><strong>Bacteria Result :</strong> {log.bacteriaResult}</p>
            </div>
          ))
        ) : (
          <p style={styles.noData}>No bacteria logs available...</p>
        )}
      </div>
    </div>
  );
}

// Inline CSS Styles
const styles = {
  container: {
    width: "80%",
    margin: "auto",
    textAlign: "center",
    padding: "20px",
    background: "#f9f9f9",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  heading: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "20px",
  },
  logsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxHeight: "520px",
    overflowY: "auto",
    padding: "10px",
  },
  logCard: {
    background: "white",
    padding: "2px",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    textAlign: "left",
    borderLeft: "5px solid #007bff",
  },
  passStatus: {
    color: "green",
    fontWeight: "bold",
  },
  failStatus: {
    color: "grey",
    fontWeight: "bold",
  },
  noData: {
    fontSize: "16px",
    color: "#888",
  },
};

export default BacteriaLogs;
